import {
  ConversationPlatform,
  MinimalConversation,
  getConversationStatus,
} from "@redotech/redo-model/conversation";
import { getCustomerDisplayName } from "@redotech/redo-model/customer";
import { RedoCheckbox } from "@redotech/redo-web/arbiter-components/checkbox/redo-checkbox";
import { Flex } from "@redotech/redo-web/flex";
import { RedoSupportChannelBadge } from "@redotech/redo-web/support/redo-support-channel-badge";
import { Text } from "@redotech/redo-web/text";
import { getDateString } from "@redotech/util/date-format";
import { memo } from "react";
import { ConversationStatusPill } from "../conversation-status-pill";
import * as mergeModalCss from "./merge-modal.module.css";

export const ConversationListItem = memo(function ConversationListItem({
  conversation,
  isSelected,
  onToggle,
}: {
  conversation: MinimalConversation;
  isSelected: boolean;
  onToggle: () => void;
}) {
  const mostRecentMessage = conversation.lastMessage;

  return (
    <Flex
      align="center"
      className={mergeModalCss.conversationListItem}
      gap="md"
      justify="space-between"
      onClick={onToggle}
      p="md"
    >
      <Flex
        align="center"
        className={mergeModalCss.conversationLeftSection}
        gap="md"
        p="sm"
      >
        <RedoCheckbox setValue={onToggle} value={isSelected} />
        <Flex dir="column" gap="xs" justify="center">
          <Text>{getCustomerDisplayName(conversation.customer)}</Text>
          {conversation.platform === ConversationPlatform.EMAIL &&
          conversation.subject ? (
            <Text fontSize="xs" textColor="secondary">
              {conversation.subject}
            </Text>
          ) : (
            <Text fontSize="xs" textColor="secondary">
              {mostRecentMessage?.content &&
              mostRecentMessage.content.length > 70
                ? `${mostRecentMessage.content.slice(0, 70)}...`
                : mostRecentMessage?.content}
            </Text>
          )}
        </Flex>
      </Flex>

      <Flex className={mergeModalCss.conversationMiddleSection}>
        <RedoSupportChannelBadge platform={conversation.platform} />
        <ConversationStatusPill
          conversationStatus={getConversationStatus(conversation)}
        />
      </Flex>

      <Text
        className={mergeModalCss.conversationRightSection}
        fontSize="sm"
        textColor="tertiary"
      >
        {getDateString(new Date(conversation.lastResponseAt))}
      </Text>
    </Flex>
  );
});
